import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ offset = 0 }) {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    try {
      if (hash) {
        // try to scroll to element referenced by hash (id or selector)
        const id = hash.startsWith("#") ? hash.slice(1) : hash;
        const el = document.getElementById(id) || document.querySelector(hash);
        if (el) {
          // smooth scroll to element
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
      }
      // otherwise scroll to top of page
      window.scrollTo({ top: offset, left: 0, behavior: "auto" });
    } catch (e) {
      try {
        window.scrollTo(0, offset);
      } catch (_) {
        /* ignore */
      }
    }
  }, [pathname, hash, offset]);
  return null;
}
